<template>
	<div class="d-flex align-center" v-m2-span>
		<div style="max-width: 220px;">
			<div class="d-flex align-center justify-space-between item-background-hover" style="gap: 10px;">
				<p class="mb-0" style="font-size: 10px;">Historial del Proyecto</p>
				<ProjectAnnulationInfo
					:item_type="item.item_type"
					:item_id="item.item_id"
					:project="project"
				/>
			</div>
			<v-divider class="my-1"></v-divider>
			<div class="d-flex align-center justify-space-between item-background-hover" style="gap: 10px;">
				<div class="caption" style="width: 200px">
					<div style="width: 100px; font-size:10px;">Subcontratista:</div>
					<b class="mb-0" style="flex: 1;">{{ subContractor || 'Sin Subcontratista' }}</b> <!-- - ID:{{ item.id }} -->
					<p class="mb-0" style="font-size: 10px;" v-if="item?.contractor?.email">{{ item.contractor.email }}</p>
				</div>
				<div class="d-flex flex-column">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-if="item.contractor"
								dark
								icon
								small
								color="#959595"
								@click="toSubcontractorChat"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon dark size="20">mdi-comment-account-outline</v-icon>
							</v-btn>
						</template>
						<span>Chatear con Subcontratista</span>
					</v-tooltip>
					<v-menu 
						v-model="subcontractorMenu" 
						offset-y 
						z-index="9999" 
						:close-on-content-click="false" 
						content-class="menu-bg-white"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-tooltip bottom>
								<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
									<v-btn
										icon
										color="warning"
										small
										v-bind="{ ...attrs, ...tooltipAttrs }"
										v-on="{ ...on, ...tooltipOn }"
									>
										<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
									</v-btn>
								</template>
								<span>Cambiar Subcontratista</span>
							</v-tooltip>
						</template>
						<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
							<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
								<p class="caption mb-0 font-weight-bold white--text">Cambiar Subcontratista</p>
							</v-list-item>
							<v-list-item-group color="#524D4D">
								<v-list-item
									v-for="(subcontractor, index) in usersList"
									:key="index"
									dense
									:disabled="disabledSubcontractor(subcontractor)"
									@click="handleChangeSubcontractor(subcontractor)"
								>
									<v-list-item-title dense>
										<div class="d-flex align-center">
											<img 
												:src="subcontractor.profile.avatar" 
												class="user-avatar mr-2" 
												v-if="subcontractor?.profile?.avatar"
											/>
											<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">
												mdi-account
											</v-icon>
											<div>
												<p class="mb-0">
													{{ subcontractor.profile?.name }} 
													{{ subcontractor.profile?.lastname }} 
													{{ subcontractor.profile?.second_lastname }}
												</p>
												<p class="mb-0 caption">{{ subcontractor.email }}</p>
											</div>
										</div>
									</v-list-item-title>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-menu>
				</div>
			</div>
			<div class="d-flex align-center justify-end mt-2">
				<div class="d-flex flex-1">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								outlined
								color="black"
								x-small
								block
								v-bind="attrs"
								v-on="on"
								:disabled="!item.contractor"
								@click="startContractorContractRequest"
							>
								<v-icon dark small>mdi-briefcase-plus-outline</v-icon>
								<p class="mb-0 ml-2">Asignar Proyectos</p>
							</v-btn>
						</template>
						<span>Asigna los proyectos seleccionados a este subcontratista</span>
					</v-tooltip>
				</div>
			</div>
		</div>
		<ManageSubcontract
			v-if="manageSubcontractModal"
			:showModal="manageSubcontractModal"
			:closeModal="closeManageSubcontractModal"
			:item="item"
			:project="project"
			:subcontracts_info="subcontracts_info"
			:full_subcontracts_info="full_subcontracts_info"
			:loadingCreation="loadingCreation"
			@onConfirm="startContractorContract"
		/>
	</div>
</template>

<script>
import {createContractorContract} from '@/helpers/api/contracts'
import contractStatuses from '@/components/Helpers/Constants/contract.js'
import ManageSubcontract from '@/components/Modals/Contracts/ManageSubcontract'
import ProjectAnnulationInfo from '@/components/Views/Projects/SettingsParts/ProjectAnnulationInfo'
import {createUserChatRoom} from '@/helpers/api/chats'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

export default {
	name: 'ContractorSelection',
	components: { ManageSubcontract, ProjectAnnulationInfo },
	props: {
		item: {
			type: Object,
			required: true
		},
		project: {
			type: Object,
			required: true
		},
		main_contract: {
			type: Object,
			required: false
		},
		subcontracts_info: {
			type: Object,
			required: true
		},
		full_subcontracts_info: {
			type: Object,
			required: false
		}
	},
	computed: {
		contractCode() {
			const contract = this.contract
			if(this.main_contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${this.main_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		hasSignedContract(){
			return this.item.subcontract?.contract?.last_status?.status >= contractStatuses.FIRMADO_CONTRAPARTE
		},
		subContractor(){
			if(this.item.contractor?.profile){
				return this.item.contractor?.profile?.name + ' ' + this.item.contractor?.profile?.lastname + ' ' + this.item.contractor?.profile?.second_lastname	
			}
			return 'Sin Subcontratista'
		},
		usersList(){
			return this.$store.state.users.usersList.filter(user => {
				return user.company_rol?.capabilities?.subcontractor === true
			})
		},
		contractorItemIds() {
			const contractorId = this.item.contractor_id
			let ids = []
			if (this.subcontracts_info.cost_table && this.subcontracts_info.cost_table.contractor_id === contractorId) {
				ids.push(this.subcontracts_info.cost_table.id)
			}
			if (this.subcontracts_info.reception && this.subcontracts_info.reception.contractor_id === contractorId) {
				ids.push(this.subcontracts_info.reception.id)
			}
			ids = ids.concat(
				(this.subcontracts_info.stages || [])
					.filter(stage => stage.contractor_id === contractorId)
					.map(stage => stage.id)
			)
			ids = ids.concat(
				(this.subcontracts_info.specialties || [])
					.filter(spec => spec.contractor_id === contractorId)
					.map(spec => spec.id)
			)
			return ids
		},
		contract(){
			return this.item.subcontract?.contract
		},
		contractorItemNames() {
			const contractorId = this.item.contractor_id
			let names = []
			if (this.subcontracts_info.cost_table && this.subcontracts_info.cost_table.contractor_id === contractorId) {
				names.push(this.project?.info?.project_type?.name)
			}
			if (this.subcontracts_info.reception && this.subcontracts_info.reception.contractor_id === contractorId) {
				names.push('Recepción')
			}
			names = names.concat(
				(this.subcontracts_info.stages || [])
					.filter(stage => stage.contractor_id === contractorId)
					.map(stage => stage.stage?.stage?.name)
			)
			names = names.concat(
				(this.subcontracts_info.specialties || [])
					.filter(spec => spec.contractor_id === contractorId)
					.map(spec => spec.specialty?.specialty?.name)
			)
			return names
		}
	},
	watch: {
	},
	data() {
		return{
			contractStatuses,
			manageSubcontractModal: false,
			subcontractorMenu: false,
			acceptRejectModal: false,
			acceptRejectModalData: null,
			loadingCreation: false
		}
	},
	mounted(){
		console.log('[DEBUG] item', this.item)
		// console.log('subcontracts_info', this.subcontracts_info)
		// console.log('full_subcontracts_info', this.full_subcontracts_info)
	},
	methods: {
		async toSubcontractorChat(){
			if(!this.item.contractor_id) return;
			const user_chat = await createUserChatRoom({user_id: this.item.contractor_id})
			if(user_chat.code == 200){
				this.$store.commit('general/addChatRoomCenter', user_chat.chat_room)
				// window.open(
				// 	`/built-in-content?type=chatroom&id=${user_chat.chat_room.id}`,
				// 	'',
				// 	'width=550,height=700,toolbar=no,menubar=no,location=no,status=no'
				// );
			}
		},
		disabledSubcontractor(contractor){
			const disable_contractor = this.full_subcontracts_info.mainProjects.some(mp => (
				mp.item_id == this.item.item_id &&
				mp.item_type == this.item.item_type &&
				mp.contractor_id == contractor.id &&
				!!mp.annulated_subcontract
			))
			return disable_contractor
		},
		closeManageSubcontractModal(){
			this.manageSubcontractModal = false
		},
		closeModalAcceptRejectModal(data){
			if(data){
				this.startContractorContract()
			}
			this.acceptRejectModalData = null
			this.acceptRejectModal = false
		},
		startContractorContractRequest(){
			this.manageSubcontractModal = true
			// const itemsList = this.contractorItemNames
			// 	.map(name => `<li class="font-weight-bold">${name}</li>`)
			// 	.join("")

			// this.acceptRejectModalData = {
			// 	title: 'Gestionar Subcontrato',
			// 	html_content: true,
			// 	content_a: `
			// 		<p class="mb-0">
			// 			Vas a gestionar el contrato con el proveedor <b>${this.subContractor}</b>.
			// 		</p>
			// 		<p>
			// 			Los <b>subcontratos</b> que se incluirán en este contrato son:
			// 		</p>
			// 		<ul class="mb-2">${itemsList}</ul>
			// 		<p class="font-weight-bold">¿Deseas continuar?</p>
			// 	`,
			// }
			// this.acceptRejectModal = true
		},
		async startContractorContract(confirm_data){
			this.loadingCreation = true
			const data = {
				parent_contract_id: this.project.contract?.id,
				contract_id: this.item.subcontract?.contract_id,
				contractor_id: this.item.contractor_id,
				...confirm_data
			}
			const contract = await createContractorContract(data)
			if(contract.code == 200){
				// this.toContractDetail(contract.contract)
				this.closeManageSubcontractModal()
				eventBus.$emit('reloadInformation')
			}
			this.loadingCreation = false
		},
		toContractDetail(contract){
			this.$store.commit('contracts/setSubcontractComponentModalId', contract.id)
		},
		removeSubcontractor(){
			const newItem = {
				...this.item,
				...{contractor: null, contractor_id: null}
			}
			this.$emit('update:contractor', newItem);
		},
		handleChangeSubcontractor(contractor){
			const newItem = {
				...this.item,
				...{contractor, contractor_id: contractor.id}
			}
			this.$emit('update:contractor', newItem);
		}
	}
}
</script>